<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Contact />
    <Footer />
  </div>
</template>

<style>
@import url("https://fonts.googleapis.com/css?family=Muli:300,400,600,700,800,900");
@import url("https://use.fontawesome.com/releases/v5.6.3/css/all.css");
</style>

<script>
import Navbar from "@/components/Navbar.vue";
import Contact from "@/components/ContactForm.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "app",
  components: {
    Navbar,
    Contact,
    Footer
  },
  methods: {
    track() {
      this.$ga.page("/");
    }
  }
};
</script>
